import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutReplaceUserErrorSlideout extends Layout {
    labelFailCount: Label;
    labelFailed: Label;
    panelFailed: Panel;
    sourceReplaceUser: DataSource;
    tableFails: Table;
}
